module.exports = __webpack_public_path__ + "img/medalla3.d2dfee1d.png";